import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Pagination,
  PaginationItem,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import {
  LoadingButton,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineSeparator,
  Timeline
} from '@mui/lab';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import Iconify from 'src/components/Iconify';
import { useLocation, useNavigate } from 'react-router-dom';
import { Table } from '@material-ui/core';
import { api } from 'src/Api';
import CloseIcon from '@mui/icons-material/Close';

import NotesIcon from '@mui/icons-material/Notes';
// import moment from 'moment';
import moment from 'moment-timezone';
import { lastIndexOf } from 'lodash';

export default function Tracking() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const userData = JSON.parse(user);
  const {
    service_id,
    service_name,
    sub_service_id,
    sub_service_name,
    customer_name,
    check_data,
    customer_id
  } = location.state || {};

  const [listData, setListData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [loading, setloading] = useState(false);
  const [saveloading, setSaveloading] = useState(false);
  const [openCommunication, setopenCommunication] = useState(false);
  const [notes, setnotes] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const [btntab, setBtntab] = useState(false);
  const [steploading, setsteploading] = useState(false);
  const [currentindex, setcurrentindex] = useState(0);
  useEffect(() => {
    if (check_data) {
      setListData(check_data);
    }
  }, [check_data]);

  useEffect(() => {
    setsteploading(true);
    setloading(true);
    handleGetSteps();
  }, [customer_id]);

  const handleGetSteps = () => {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    fetch(`${api.get_service_detail_steps}?customer_service_id=${customer_id}`, {
      headers: myHeaders,
      method: 'GET'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setListData(result.data);
        } else {
          console.log('Error:', result.message);
        }
        setloading(false);
      })
      .catch((error) => {
        console.log('Fetch error:', error);
      })
      .finally(() => {
        setsteploading(false);
        setloading(false);
      });
  };
  const handleUpdateService = (id, check) => {
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('id', id);
    formData.append('isCompleted', check);

    // if (check == 1) {
    //   formData.append('lat', currentLocation?.lat === undefined ? 0 : currentLocation?.lat);

    //   formData.append('lon', currentLocation?.lng === undefined ? 0 : currentLocation?.lng);
    // }

    fetch(api.update_customer_services, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setListData(result.data?.additional_info_checks);
          if (result?.data?.status === 'completed') {
            setTimeout(() => {
              navigate('/dashboard/services', { replace: true });
            }, 2000);
          } else {
            handleGetSteps();
          }
        } else {
          // setBtntab(false);
          console.log('Error:', result.message);
        }
        // setloading(false);
        // setBtntab(false);
      })
      .catch((error) => {
        // setBtntab(false);
        console.log('Fetch error:', error);
        setloading(false);
      })
      .finally(() => {
        setBtntab(false);
        // setTimeout(() => {
        //   setBtntab(false);
        // }, 1000);
        setloading(false);
      });
  };

  const Notesdescribtion = () => {
    setSaveloading(true);

    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    var formdata = new FormData();
    formdata.append('id', selectedId);
    formdata.append('notes', notes);

    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders
    };

    fetch(api.update_notes, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const des = result?.data?.notes;
          if (des === 'null') {
            setnotes('');
          } else {
            setnotes(des);
          }
          handleGetSteps();
          closeCommunicationModal();
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setTimeout(() => {
            setSnackbarOpen(false);
          }, 2000);
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setTimeout(() => {
            setSnackbarOpen(false);
          }, 2000);
        }
      })
      .catch((error) => {
        console.error(error);
        setSnackbarOpen(true);
        setSnackbarMessage(error.message);
        setSnackbarSeverity('error');
        setTimeout(() => {
          setSnackbarOpen(false);
        }, 2000);
      })
      .finally(() => {
        setSaveloading(false);
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCheckboxPress = (index) => {
    if (index == 0 || listData[index - 1].isCompleted == 1) {
      setcurrentindex(index);
      const newData = listData.map((item, i) =>
        i == index ? { ...item, isCompleted: item.isCompleted == 0 ? 1 : 0 } : item
      );
      setListData(newData);
      handleUpdateService(newData[index].id, newData[index].isCompleted);
    } else {
      setSnackbarOpen(true);
      setSnackbarSeverity('error');
      setSnackbarMessage('Steps must be completed in a sequence');
      setBtntab(false);
      setloading(false);
    }
  };

  function openCommunicationModal(id, note) {
    if (note) {
      setnotes(note);
    }
    setSelectedId(id);
    setopenCommunication(true);
  }

  const closeCommunicationModal = () => {
    setSelectedId('');
    setopenCommunication(false);
    setnotes('');
  };

  const lastCompletedIndex = listData
    .map((item, index) => (item.isCompleted !== 0 ? index : -1)) // Get indices where isCompleted != 0
    .filter((index) => index !== -1) // Filter out invalid indices (-1)
    .pop(); // Get the last valid index (the last one with isCompleted != 0)
  useEffect(() => {
    setcurrentindex(lastCompletedIndex);
  }, []);

  return (
    <Page title={`Tracking | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center">
            <IconButton
              style={{
                marginRight: 12,
                height: 40,
                width: 70,
                borderRadius: 5,
                backgroundColor: 'rgba(249, 0, 1,0.1)'
              }}
              onClick={() => navigate(-1)}
            >
              <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
            </IconButton>

            <Typography variant="h4" sx={{ color: '#f90001' }}>
              Tracking
            </Typography>
          </Stack>
        </Stack>

        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openCommunication}
          onClose={closeCommunicationModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '60%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1
            }}
            className="admin_modal_pa"
          >
            <Box
              sx={{
                width: '100%',
                bgcolor: 'background.paper',
                p: 2
              }}
            >
              <Box display={'flex'} justifyContent={'space-between'} pb={1} alignItems="center">
                <Typography
                  variant="h6"
                  style={{ fontWeight: 'bold', textAlign: 'center', color: '#f90001' }}
                >
                  Add Notes
                </Typography>
                <IconButton onClick={closeCommunicationModal} edge="end">
                  <CloseIcon />
                </IconButton>
              </Box>
              <TextField
                fullWidth
                multiline
                rows={4}
                label="Note"
                variant="outlined"
                name="Note"
                value={notes}
                onChange={(e) => setnotes(e.target.value)}
              />
              <Grid mb={-2} xs={12} display={'flex'} justifyContent={'flex-end'} mt={2}>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  onClick={Notesdescribtion}
                  loading={saveloading}
                  // disabled={saveloading}
                  disabled={!notes || saveloading}
                >
                  {'Send'}
                </LoadingButton>
              </Grid>
            </Box>
          </Box>
        </Modal>

        <Box
          sx={{
            flex: 1,
            margin: 'auto',
            padding: 2,
            boxShadow: 3,
            borderRadius: 2,
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            mt: 2,
            mb: 2,
            minWidth: 800
          }}
        >
          <Box sx={{ padding: 2, backgroundColor: '#f5f5f5', borderRadius: 2, mb: 2 }}>
            <Typography variant="h6">Customer Details</Typography>
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Typography variant="body2" style={{ width: 150 }}>
                Customer Name:
              </Typography>
              <Typography
                variant="body2"
                style={{
                  fontWeight: 'bold',
                  color: '#f90001',
                  marginLeft: 10,
                  textTransform: 'capitalize'
                }}
              >
                {customer_name}
              </Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Typography variant="body2" style={{ width: 150 }}>
                Sub Service Name:
              </Typography>
              <Typography
                variant="body2"
                style={{
                  fontWeight: 'bold',
                  color: '#f90001',
                  marginLeft: 10,
                  textTransform: 'capitalize'
                }}
              >
                {sub_service_name}
              </Typography>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Typography variant="body2" style={{ width: 150 }}>
                Service Name:
              </Typography>
              <Typography
                variant="body2"
                style={{
                  fontWeight: 'bold',
                  color: '#f90001',
                  marginLeft: 10,
                  textTransform: 'capitalize'
                }}
              >
                {service_name}
              </Typography>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Typography variant="body2" style={{ width: 150 }}>
                Business Name:
              </Typography>
              <Typography
                variant="body2"
                style={{
                  fontWeight: 'bold',
                  color: '#f90001',
                  marginLeft: 10,
                  textTransform: 'capitalize'
                }}
              >
                {userData.name}
              </Typography>
            </div>
            {/* <Typography variant="body2" color="success.main">
              Service Status: Active
            </Typography> */}
          </Box>

          <Box sx={{ width: '100%' }}>
            <Timeline
              sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                  flex: 0,
                  padding: 0
                }
              }}
            >
              {listData.map((val, index) => {
                console.log('list data ', val);

                const isCurrentChecked = listData[index]?.isCompleted != 0;
                const isLastIndex = index == listData.length - 1;

                console.log('Last index with isCompleted != 0:', isCurrentChecked);
                return (
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start'
                    }}
                  >
                    <TimelineItem
                      sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'row'
                      }}
                      key={val.id}
                    >
                      <TimelineSeparator>
                        <TimelineDot
                          style={{
                            height: 15,
                            width: 15,
                            marginBottom: 3,
                            borderRadius: 100,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: 5,
                            backgroundColor: '#ffffff'
                          }}
                        >
                          <Radio
                            // disabled={
                            //   true
                            // btntab ||
                            // (listData.length != index + 1 &&
                            //   listData[index + 1]?.isCompleted == 1)
                            //   ? true
                            //   : false
                            // }
                            checked={isCurrentChecked}
                            // onClick={() => {
                            //   setBtntab(true);
                            //   handleCheckboxPress(index);
                            // }}
                            size="small"
                          />
                        </TimelineDot>
                        {isLastIndex == 0 && (
                          <TimelineConnector
                            sx={{
                              bgcolor: 'transparent',
                              height: 'auto',
                              width: 0,
                              display: 'flex',
                              flexDirection: 'column',
                              marginRight: 0.3
                            }}
                          >
                            <div
                              style={{
                                height: 50,
                                flex: 1,
                                // border: isCurrentChecked
                                //   ? '1.5px dashed #f90001'
                                //   : '1.5px dashed #777682'

                                border: `1.5px dashed ${
                                  index == lastCompletedIndex
                                    ? '#f90000'
                                    : index == currentindex
                                    ? listData[index]?.isCompleted == 1
                                      ? '#f90001'
                                      : '#777682'
                                    : index == currentindex - 1 &&
                                      listData[currentindex]?.isCompleted == 0
                                    ? '#f90001'
                                    : index < currentindex && listData[index]?.isCompleted == 1
                                    ? '#777682'
                                    : '#777682'
                                }`
                              }}
                            />
                          </TimelineConnector>
                        )}
                      </TimelineSeparator>
                      <TimelineContent
                        style={{ height: 50, marginBottom: 10, paddingTop: 0, paddingLeft: 10 }}
                      >
                        <Typography variant={'body1'} component="span" style={{ fontWeight: 600 }}>
                          {val?.services_aditional_info?.name}
                        </Typography>

                        {isCurrentChecked && (
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: {
                                xs: '0.55rem',
                                sm: '0.575rem',
                                md: '0.6rem'
                              },
                              lineHeight: { xs: '1.3', sm: '1.3', md: '1.2' },
                              display: '-webkit-box',
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              WebkitLineClamp: 2,
                              height: 20
                            }}
                          >
                            {/* {val?.updated_at &&
                              moment(val?.updated_at).format('MM-DD-YYYY, h:mm A')} */}
                            {val?.updated_at &&
                              moment
                                .utc(val?.updated_at)
                                .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                                .format('DD-MMM-YYYY h:mm A')}
                          </Typography>
                        )}
                        {val?.notes ? (
                          <Box
                            sx={{
                              width: '100%',
                              maxWidth: { xs: '500px', sm: '600px', lg: '700px' }
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontSize: {
                                  xs: '0.55rem',
                                  sm: '0.575rem',
                                  md: '0.6rem'
                                },
                                lineHeight: { xs: '1.3', sm: '1.3', md: '1.2' },
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 2,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'normal'
                              }}
                            >
                              {val?.notes}
                            </Typography>
                          </Box>
                        ) : (
                          <div style={{ height: 35 }} />
                        )}
                      </TimelineContent>
                      <LoadingButton
                        variant="contained"
                        style={{
                          height: 25,
                          fontSize: 10,
                          borderRadius: 5,
                          width: 50,
                          display: 'flex',
                          justifyContent: 'space-between',
                          paddingLeft: 9,
                          paddingRight: 9
                        }}
                        onClick={() => openCommunicationModal(val?.id, val?.notes)}
                      >
                        <Iconify icon="material-symbols:add-notes-outline" height={14} width={14} />
                        Notes
                      </LoadingButton>
                    </TimelineItem>
                  </Box>
                );
              })}
              {loading && (
                // <TimelineItem>
                //   <TimelineContent
                //     sx={{
                //       display: 'flex',
                //       justifyContent: 'center',
                //       alignItems: 'center',
                //       height: '100px', // Adjust height as needed
                //       width: '100%' // Ensures full width for alignment
                //     }}
                //   >
                //     <TableBody>
                //       <TableRow>
                //         <TableCell
                //           align="center"
                //           colSpan={3}
                //           sx={{
                //             py: 3,
                //             display: 'flex',
                //             justifyContent: 'center', // Centers horizontally
                //             alignItems: 'center', // Centers vertically
                //             height: '100px', // Adjust height if needed to position spinner
                //             alignSelf: 'center'
                //           }}
                //         >
                //           <CircularProgress />
                //         </TableCell>
                //       </TableRow>
                //     </TableBody>
                //   </TimelineContent>
                // </TimelineItem>
                <Box
                  sx={{
                    position: 'fixed', // To make it overlay on the entire screen
                    top: 0,
                    left: 0,
                    width: '100vw', // Full viewport width
                    height: '100vh', // Full viewport height
                    display: 'flex',
                    justifyContent: 'center', // Center horizontally
                    alignItems: 'center', // Center vertically
                    backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional: Add a light overlay background
                    zIndex: 9999 // Ensure it appears above other elements
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
            </Timeline>
          </Box>
        </Box>

        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
